import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class VideoCaseStudyWhyUs extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };

    render() {
        const { data } = this.props;

        return (
            <div className="component-video-case-study-why-us">
                <div className="v3-container">
                    <div className="section-block top">
                        <h3 className="block-title" dangerouslySetInnerHTML={{ __html: data.title }} />
                        {data.description ? <p className="block-description" dangerouslySetInnerHTML={{ __html: data.description }} /> : null}
                        <div className="list">
                            {data.elements.map((element, index) => {
                                switch (element.type) {
                                    case '3-cols':
                                        return (
                                            <div key={index} className="list-element cols-3" style={element.styles}>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.titleLeft}</h4>
                                                    <p className="element-text">{element.descLeft}</p>
                                                </div>
                                                <div className="col col-mixed">
                                                    <img className="element-icon" src={element.dividerIcon} />
                                                    <p className="element-text">{element.divider}</p>
                                                </div>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.titleRight}</h4>
                                                    <p className="element-text">{element.descRigt}</p>
                                                </div>
                                            </div>
                                        );
                                    case '4-cols':
                                        return (
                                            <div key={index} className="list-element cols-4" style={element.styles}>
                                                <div className="element-info">{element.col1Title}</div>
                                                <div className="col col-icon">
                                                    <img className="element-icon" src={element.col1Icon} />
                                                </div>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.col12itle}</h4>
                                                    <p className="element-text">{element.col2Desc}</p>
                                                </div>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.col3Title}</h4>
                                                    <p className="element-text">{element.col3Desc}</p>
                                                </div>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.col4Title}</h4>
                                                    <p className="element-text">{element.col4Desc}</p>
                                                </div>
                                            </div>
                                        );
                                    default:
                                        return (
                                            <div key={index} className="list-element" style={element.styles}>
                                                <div className="col col-icon">
                                                    <img className="element-icon" src={element.icon} />
                                                </div>
                                                <div className="col col-text">
                                                    <h4 className="element-title">{element.title}</h4>
                                                    <p className="element-text">{element.desc}</p>
                                                </div>
                                            </div>
                                        );
                                }
                            })}
                        </div>
                    </div>
                </div>
                <img className="background-side" src={data.sideBg} />
                <img className="photo-side photo-side-1" src={data.photo1} />
                <img className="photo-side photo-side-2" src={data.photo2} />
                <img className="photo-side photo-side-3" src={data.photo3} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/videoCaseStudy/WhyUs/index.js